// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__29oDy","title":"style_title__OT8h4","subtitle":"style_subtitle__1KWxb"};